import { Injectable } from "@angular/core";

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  // label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    // label: "Navigation",
    main: [
      {
        main_state: "admin",
        state: "dashboard",
        short_label: "D",
        name: "Dashboard",
        type: "link",
        icon: "ti-home",
      },
      {
        main_state: "admin",
        state: "user",
        short_label: "U",
        name: "Users",
        icon: "ti-user",
        type: "link",
      },
      {
        main_state: "admin",
        state: "affiliates",
        short_label: "A",
        name: "Affiliates",
        icon: "ti-shine",
        type: "link",
        // children: [
        //   {
        //     state: 'cpa',
        //     name: 'CPA'
        //   },
        //   {
        //     state: 'revshare',
        //     name: 'RevShare'
        //   }
        // ]
      },
      {
        main_state: "admin",
        state: "transactions",
        short_label: "T",
        name: "Transactions",
        icon: "ti-layers-alt",
        type: "link",
      },
      {
        main_state: "admin",
        state: "withdrawRequests",
        short_label: "WR",
        name: "Withdraw Requests",
        icon: "ti-envelope",
        type: "link",
      },
      {
        main_state: "admin",
        state: "liquidityRewardClaims",
        short_label: "LRC",
        name: "Liquidity Reward Claims",
        icon: "ti-gift",
        type: "link",
      },
      {
        main_state: "admin",
        state: "kycRewardClaims",
        short_label: "KRC",
        name: "KYC Reward Claims",
        icon: "ti-id-badge",
        type: "link",
      },
      {
        main_state: "admin",
        state: "sendToken",
        short_label: "SP",
        name: "Send eMaaya",
        icon: "ti-rocket",
        type: "link",
      },
      // {
      //   main_state: "admin",
      //   state: "bulkTokenTransfer",
      //   short_label: "B",
      //   name: "Bulk Token Transfer",
      //   icon: "ti-server",
      //   type: "link",
      // },
      // {
      //   main_state: "admin",
      //   state: "wiretransferclaims",
      //   short_label: "W",
      //   name: "Wire Transfer Claims",
      //   icon: "fa fa-wpforms",
      //   type: "link",
      // },
      // {
      //   main_state: 'admin',
      //   state: 'kyc',
      //   short_label: 'U',
      //   name: 'KYC',
      //   icon: 'ti-id-badge',
      //   type: 'link'
      // },
      // {
      //   main_state: 'admin',
      //   state: 'blog',
      //   short_label: 'B',
      //   name: 'Blog',
      //   icon: 'ti-pencil-alt',//ti-align-justify
      //   type: 'link'
      // },
      // {
      //   main_state: 'admin',
      //   state: 'earlyBirds',
      //   short_label: 'E',
      //   name: 'Early Birds',
      //   icon: 'ti-layout-media-left',
      //   type: 'link'
      // },
      // {
      //   main_state: 'admin',
      //   state: 'newsletterSubscription',
      //   short_label: 'N',
      //   name: 'Newsletter Subscription',
      //   icon: 'ti-email',
      //   type: 'link'
      // },
      // {
      //   main_state: 'admin',
      //   state: 'smartContract',
      //   short_label: 'S',
      //   name: 'Smart Contract',
      //   icon: 'ti-write',
      //   type: 'link'
      // },
      {
        main_state: "admin",
        state: "blastMessage",
        short_label: "BM",
        name: "Blast Message",
        icon: "ti-image",
        type: "link",
      },
      {
        main_state: "admin",
        state: "promoVideo",
        short_label: "PV",
        name: "Promo Video",
        icon: "ti-video-camera",
        type: "link",
      },
      {
        main_state: "admin",
        state: "settings",
        short_label: "S",
        name: "Settings",
        icon: "ti-settings",
        type: "link",
      },
    ],
  },
];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }
}
